import get from 'lodash.get';
import { emptyObject } from 'ui-components/default-props/empty';

const selectPickBatches = (state) => get(state, 'pickBatches', emptyObject);

export const selectPickBatchById = (state, props) => get(selectPickBatches(state, props), props.pickBatchId);
